if (!wpi) {
  var wpi = {};
}

if (!wpi.mapmodule) {
  wpi.mapmodule = {};
}




wpi.mapmodule.createLayers = function(map, layerInfos) {
  var layers = []
  for(var i=0; i<layerInfos.length; i++ ){
    var layerInfo = layerInfos[i];
    var layer;
    if (layerInfo.type === "Group") {
      layer = new ol.layer.Group ({
        visible: layerInfo.isVisible,
        opacity: layerInfo.opacity,
        layers: wpi.mapmodule.createLayers(map, layerInfo.layers)
      });
    }
    else {
      layer = wpi.mapmodule.createSingleLayer(map, layerInfo);
    }
    layer.key = layerInfo.key;
    layers.push(layer);
  };
  return layers;
};


wpi.mapmodule.createSingleLayer = function(map, layerInfo) {
  vectorTileLoader = function(tile, url) {
    tile.setLoader(function() {
      var client = new XMLHttpRequest();
      client.open('GET', url);
      client.responseType = "arraybuffer";
      for (var i=0; i<layerInfo.headers.length; i++) {
        client.setRequestHeader(layerInfo.headers[i][0], layerInfo.headers[i][1]);
      }
      client.onload = function() {
        var format = tile.getFormat();
        tile.setProjection(format.readProjection(client.response));
        var newfeatures;
        try {
          newfeatures = format.readFeatures(client.response, {
            // featureProjection is not required for ol/format/MVT
            featureProjection: map.getView().getProjection()
          });
        }
        catch(e) {
          newfeatures = [];
        }
        tile.setFeatures(newfeatures);
        // the line below is only required for ol/format/MVT
        tile.setExtent(format.getLastExtent());
      };
      client.send();
    });
  };

  imageTileLoader = function(tile, url) {
    var client = new XMLHttpRequest();
    client.open('GET', url);
    client.responseType = 'blob';
    for (var i=0; i<layerInfo.headers.length; i++) {
      client.setRequestHeader(layerInfo.headers[i][0], layerInfo.headers[i][1]);
    }
    client.addEventListener('loadend', function (evt) {
      var data = this.response;
      if (data !== undefined) {
        tile.getImage().src = URL.createObjectURL(data);
      } else {
        tile.setState(TileState.ERROR);
      }
    });
    client.addEventListener('error', function () {
      tile.setState(TileState.ERROR);
    });
    client.send();
  };

  var newLayer;
  var newLayerOptions = {
    visible: layerInfo.isVisible,
    opacity: layerInfo.opacity,
  };
  if (layerInfo.minResolution) {
    newLayerOptions.minResolution = layerInfo.minResolution;
  }
  if (layerInfo.maxResolution) {
    newLayerOptions.maxResolution = layerInfo.maxResolution;
  }
  if (layerInfo.type === "WMTS") {
    newLayerOptions.source = wpi.mapmodule.createWmtsSource(layerInfo.url, layerInfo.layerName, layerInfo.imgType);
    newLayer = new ol.layer.Tile(newLayerOptions);
  }
  if (layerInfo.type === "WMSTILE") {
    newLayerOptions.source = wpi.mapmodule.createTileWmsSource(layerInfo.url, layerInfo.layerName);
    newLayer = new ol.layer.Tile(newLayerOptions);
  }
  if (layerInfo.type === "XyzImgTiles") {
    newLayerOptions.source = new ol.source.XYZ({
      url: layerInfo.url,
      tileLoadFunction : imageTileLoader,
      crossOrigin: 'anonymous'
    });
    newLayer = new ol.layer.Tile(newLayerOptions);
  }
  if (layerInfo.type === "MapBoxVectorTiles") {
    newLayerOptions.declutter = true;
    newLayerOptions.source = new ol.source.VectorTile({
      format: new ol.format.MVT(),
      url: layerInfo.url,
      tileLoadFunction : vectorTileLoader
    });
    var styleObj = window[layerInfo.currentStyle];
    if (styleObj) {
        newLayerOptions.style = styleObj.style;
        wpi.mapmodule.onLegendCreated(layerInfo.key, styleObj.legend);
    }
    newLayer = new ol.layer.VectorTile(newLayerOptions);
    newLayer.styleObj = styleObj;
  }
  else if (layerInfo.type === "Vector") {
    if (layerInfo.clusterOptions) {
      var clusterSrcOptions = { source: new ol.source.Vector({}) };
      if (layerInfo.clusterOptions.distance) {
        clusterSrcOptions.distance = layerInfo.clusterOptions.distance;
      }
      // layerInfo.clusterOptions.objsReturnedOnClick is added to the newLayer after its creation, below
      newLayerOptions.source = new ol.source.Cluster(clusterSrcOptions);
    } else {
      url = layerInfo.url
      options = url ? { url: url, format: new ol.format.GeoJSON() } : {}
      newLayerOptions.source = new ol.source.Vector(options)
    }
    var styleObj = window[layerInfo.currentStyle];
    if (styleObj) {
        newLayerOptions.style = styleObj.style;
        wpi.mapmodule.onLegendCreated(layerInfo.key, styleObj.legend);
    }
    newLayer = new ol.layer.Vector(newLayerOptions);
    newLayer.styleObj = styleObj;
    if (layerInfo.select) {
      wpi.mapmodule.updateNormalModeSelectInteraction(map, newLayer);
    }
    newLayer.wpiVectorProps = {
      format: layerInfo.format,
      idPath: layerInfo.idPath,
      subObjPath : layerInfo.subObjPath,
      subObjIdPath : layerInfo.subObjIdPath
    }
    if (layerInfo.initData) {
      var features = wpi.mapmodule.createFeatures(
        layerInfo.key,
        layerInfo.format,
        layerInfo.idPath,
        layerInfo.subObjPath,
        layerInfo.subObjIdPath,
        layerInfo.initData
      );
      wpi.mapmodule.getVectLayerSrc(newLayer).addFeatures(features);
    }
    if (layerInfo.type === "Vector" && layerInfo.clusterOptions && layerInfo.clusterOptions.objsReturnedOnClick) {
      newLayer.clusterObjsReturnedOnClick = layerInfo.clusterOptions.objsReturnedOnClick;
    }
  }
  return newLayer;
};


wpi.mapmodule.getVectLayerSrc = function(layer) {
  if (layer.getSource() instanceof ol.source.Cluster) {
    return layer.getSource().getSource();
  }
  else {
    return layer.getSource();
  }
};


//Create a global select if it doesn't exist; otherwise add layer and style to existing one
  //(multiple select don't work properly on the same condition, because the event propagation is stopped)
wpi.mapmodule.updateNormalModeSelectInteraction = function(map, newLayer) {

  if (!map.normalModeSelectInteraction) {
    if (newLayer) {
      map.normalModeSelectInteractionLayers = [ newLayer ];
    } else {
      map.normalModeSelectInteractionLayers = [];
    }
  } else {
    map.removeInteraction(map.normalModeSelectInteraction);
    if (newLayer) {
      map.normalModeSelectInteractionLayers.push(newLayer);
    }
  }

  var iaOptions = {
    layers: map.normalModeSelectInteractionLayers,
    toggleCondition: ol.events.condition.never,
    style : wpi.mapmodule.createSelectStyleFn(map)
  };

  map.normalModeSelectInteraction = new ol.interaction.Select(iaOptions);
  map.addInteraction(map.normalModeSelectInteraction);
};


wpi.mapmodule.createWmtsSource = function(wmsurl, wmslayername) {
  var resolutions = [
    4000, 3750, 3500, 3250, 3000, 2750, 2500, 2250, 2000, 1750, 1500, 1250,
    1000, 750, 650, 500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1.5, 1, 0.5, 0.25, 0.1
  ];
  var tileGrid = new ol.tilegrid.WMTS({
    origin: [2420000, 1350000],
    resolutions: resolutions,
    matrixIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
  });
  return new ol.source.WMTS({
    url: wmsurl,
    tileGrid: tileGrid,
    layer: wmslayername,
    requestEncoding: 'REST',
    crossOrigin: 'anonymous'
  });
};

wpi.mapmodule.createTileWmsSource = function(tileWmsUrl, tileWmsLayerName) {
  return new ol.source.TileWMS({
    url: tileWmsUrl,
    crossOrigin: 'anonymous',
    params: { LAYERS: tileWmsLayerName, TILED: true }
  });
};

wpi.mapmodule.createWfsSource = function(url, tileWmsLayerName) {
  return new ol.source.Vector({
    format: new ol.format.GeoJSON(),
    url: url
  });
};

wpi.mapmodule.createTempVectorLayer = function(map, data, style) {
  tempLayer = new ol.layer.Vector({
    source: new ol.source.Vector({}),
    style: style
  });
  var features = wpi.mapmodule.createFeatures("____temp", "GeoJson", null, null, null, data);
  tempLayer.getSource().addFeatures(features);
  map.addLayer(tempLayer);
  map.tempLayer = tempLayer;
};


wpi.mapmodule.removeTempVectorLayer = function(map) {
  if (!map.tempLayer) return;
  map.removeLayer(map.tempLayer);
  map.tempLayer = null;
};


//Currently not used
// wpi.mapmodule.createTileWmsSource = function(wmsurl, wmslayername) {
//     return new ol.source.TileWMS({
//         url: wmsurl,
//         params: {
//             'LAYERS': wmslayername,
//             'FORMAT': 'image/jpeg'
//         }
//     })
// };


wpi.mapmodule.getAllLayers = function(map) {
  return wpi.mapmodule.getLayersFromList(map.getLayers());
};


wpi.mapmodule.getLayersFromList = function(layers) {
  var retLayers = [];
  layers.forEach(function(layer) {
    retLayers.push(layer);
    if (layer instanceof ol.layer.Group) {
      var subLayers = wpi.mapmodule.getLayersFromList(layer.getLayers());
      subLayers.forEach(function(subLayer) {
        retLayers.push(subLayer);
      });
    }
  });
  return retLayers;
};


wpi.mapmodule.findLayerByKey = function(map, key) {
  var allLayers = wpi.mapmodule.getAllLayers(map);
  for (var i=0; i<allLayers.length; i++) {
    var layer = allLayers[i];
    if (layer.key === key) {
      return layer;
    }
  }
  return null;
};


wpi.mapmodule.createSelectStyleFn = function(map) {
  return function(feature, res) {
    if (!feature.layerKey) {
      return wpi.mapmodule.defaultStyleFunction(feature);
    }
    var featLayer = wpi.mapmodule.findLayerByKey(map, feature.layerKey);
    if (!featLayer.styleObj || !featLayer.styleObj.selectStyle) {
      return wpi.mapmodule.defaultStyleFunction(feature);
    }
    if (typeof featLayer.styleObj.selectStyle === "function") {
      return featLayer.styleObj.selectStyle(feature, res);
    } else {
      return featLayer.styleObj.selectStyle;
    }
  };
};


wpi.mapmodule.defaultStyleFunction = function(feature) {
   var fill = new ol.style.Fill({
     color: 'rgba(255,255,255,0.4)'
   });
   var stroke = new ol.style.Stroke({
     color: '#3399CC',
     width: 4
   });
   var styles = [
     new ol.style.Style({
       image: new ol.style.Circle({
         fill: fill,
         stroke: stroke,
         radius: 5
       }),
       fill: fill,
       stroke: stroke
     })
   ];
   return styles;
};
